





































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeProjet, {ProjetFilter} from '@/stores/modules/projet';

import InputDateFilter from '@/components/Input/DateFilter.vue';

@Component({
	components: {
		InputDateFilter,
	}
})
export default class CrudProjetFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeProjet) private page!: number;
	@Stored(() => storeProjet) private filters!: ProjetFilter;

	@WatchObjectProperties('filters', ProjetFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeProjet.dispatch('getC', { filters: true });
	}

	public mounted() {
		this.typeWatcher();
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
